"use client";

import { useId, type FormEvent } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ga4Search } from "@/lib/analytics/ga4-ecommerce";

import SearchIcon from "@/components/icons/SearchIcon";

export default function HeroSearchInput({ query }: { query?: string }) {
	const searchInputId = useId();

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget;
		const value = new FormData(form).get("query");
		if (typeof value === "string") ga4Search(value);
	};

	return (
		<form className="contents" onSubmit={onSubmit}>
			<div className="mt-8 flex h-14 items-center gap-2 rounded-md bg-primary px-4 dark:bg-core-midnight sm:h-16">
				<SearchIcon
					className="w-6 h-6 shrink-0 text-primary-foreground dark:text-secondary"
					aria-hidden
				/>
				<label htmlFor={searchInputId} className="sr-only">
					Search for blogs
				</label>
				<Input
					id={searchInputId}
					type="search"
					name="query"
					defaultValue={query}
					placeholder="What are you looking for?"
					autoComplete="off"
					className="border-none bg-transparent text-xs text-primary-foreground placeholder:font-light placeholder:text-grey-foreground dark:text-foreground dark:placeholder:text-muted-foreground xs:text-sm sm:text-sm"
				/>
				<Button className="hidden px-8 py-6 font-normal text-secondary-foreground transition-colors duration-300 sm:inline-flex">
					Search
				</Button>
			</div>

			<Button className="mt-4 h-12 w-full rounded-full text-xs text-secondary-foreground shadow-custom xs:h-14 xs:text-sm sm:hidden">
				Search
			</Button>
		</form>
	);
}
